import { useEffect } from 'react'

export default function Modal({ icon, title, body, closeLabel, onClose }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="modal-overlay open" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal">
        <div className="modal-icon">{icon}</div>
        <h3>{title}</h3>
        <p>{body}</p>
        <button className="modal-close" onClick={onClose}>{closeLabel}</button>
      </div>
    </div>
  )
}
